import React, { useRef } from 'react';
import { useVenuesScrollTrigger } from '../hooks/gsap/useVenuesGSAP';
import '../assets/css/venue.css';

import slideshow01 from '../assets/images/slideshow-01.jpg';
import slideshow02 from '../assets/images/slideshow-02.jpg';
import slideshow03 from '../assets/images/slideshow-03.jpg';
import slideshow04 from '../assets/images/slideshow-04.jpg';
import slideshow05 from '../assets/images/slideshow-05.jpg';
import slideshow06 from '../assets/images/slideshow-06.jpg';
import { getGalleryImageSources } from '../assets/images/responsiveImages';

const venueImage = (name, fallback) => ({
  fallback,
  ...getGalleryImageSources(name),
});

const VenuesSection = () => {
  const containerRef = useRef(null);

  // Use GSAP scroll trigger for venues
  useVenuesScrollTrigger(containerRef);

  const venues = [
    { name: 'ELECTROWERKZ', image: venueImage('slideshow-01', slideshow01) },
    { name: 'EGG', image: venueImage('slideshow-02', slideshow02) },
    { name: 'FABRIC', image: venueImage('slideshow-03', slideshow03) },
    { name: 'MATTER', image: venueImage('slideshow-04', slideshow04) },
    { name: 'FIRE', image: venueImage('slideshow-05', slideshow05) },
    { name: 'CABLE', image: venueImage('slideshow-06', slideshow06) },
  ];

  return (
    <section id="venues" className="venues-section section-breakpoint" ref={containerRef}>
      {venues.map((venue, index) => (
        <div key={index} className="venue-slide">
          <picture>
            <source
              type="image/webp"
              srcSet={`${venue.image.thumbnail} 480w, ${venue.image.medium} 960w, ${venue.image.mediumLarge} 1280w, ${venue.image.desktop} 1600w, ${venue.image.large} ${venue.image.largeWidth}w`}
              sizes="100vw"
            />
            <img
              src={venue.image.fallback}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div
            className="venue-name">{venue.name}</div>
        </div>
      ))}
    </section>
  );
};

export default VenuesSection;
